import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

/** The admin console is only for admins, so it loads on demand (spec §15: admin is lazy). */
const AdminPanel = lazy(() => import('./AdminPanel.js').then((m) => ({ default: m.AdminPanel })));

export function LazyAdminPanel({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<p className="notice">{t('connection.connecting')}</p>}>
      <AdminPanel onClose={onClose} />
    </Suspense>
  );
}
